import { ReactNode } from "react";

import { ENABLE_APP_SIDEBAR_REDESIGN } from "../../config/constants";
import { MainContentViewLayoutLegacy } from "./legacy/MainContentViewLayoutLegacy";
import { MainContentViewLayoutNew } from "./MainContentViewLayoutNew";

interface MainContentViewLayoutProps {
  children: ReactNode;
  currentPath: string;
}

export const MainContentViewLayout = (props: MainContentViewLayoutProps) =>
  ENABLE_APP_SIDEBAR_REDESIGN ? (
    <MainContentViewLayoutNew {...props} />
  ) : (
    <MainContentViewLayoutLegacy {...props} />
  );
